import { createActions } from "redux-actions";

export default createActions({
  AMBASSADORS: {
    AMBASSADORS: {
      SUCCESS: (data) => ({ data }),
      FAILURE: (data) => ({ data }),
      GET_MANAGER_RECRUITMENTS: (prefId, serviceId) => ({ prefId, serviceId }),
      GET_PREF_LIST: () => ({}),
      GET_SERVICE_LIST: () => ({}),
    },
  },
});
